import { useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Loader, PageLayoutTabs } from '@thinknet-gmbh/platform-common-ui';

import { useRouteQuery } from 'src/common/helpers';
import { useGetVacancyById } from 'src/hooks/vacancies-patterns/get-vacancy-by-id.hook';

import { VACANCY_DETAILS_TABS } from './vacancy-details.constants';
import { VacancyDetailsInfo } from './components/vacancy-details-info';
import { Applicants } from './components/applicants';
import { VacancyDetailsEdit } from './components/vacancy-details-edit';
import { ApplicantDetails } from './components/applicants/components/applicant-details';

const VacancyDetails = () => {
  const { t } = useTranslation('vacancies');
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const vacancyId = params.id?.slice(4);
  const query = useRouteQuery();
  const type = query.get('type') || '';
  const [isEdit, setIsEdit] = useState(false);
  const { vacancy, loading } = useGetVacancyById(vacancyId);

  if (loading) {
    return <Loader />;
  }

  return (
    <PageLayoutTabs
      defaultTab={
        type === VACANCY_DETAILS_TABS.applicantDetails ? VACANCY_DETAILS_TABS.applicants : type
      }
      pageTitle={`${t('labels.vacancy')} "${vacancy.job.title}"`}
      onTabChange={tab => navigate(`${location.pathname}?type=${tab}`)}
      elements={[
        {
          tab: t('labels.vacancyDetails'),
          tabIndex: VACANCY_DETAILS_TABS.vacancyDetails,
          component: isEdit ? (
            <VacancyDetailsEdit vacancy={vacancy} onClickCancelBtn={() => setIsEdit(false)} />
          ) : (
            <VacancyDetailsInfo vacancy={vacancy} onClickEditBtn={() => setIsEdit(true)} />
          ),
        },
        {
          tab: t('labels.applicants'),
          tabIndex: VACANCY_DETAILS_TABS.applicants,
          component:
            type === VACANCY_DETAILS_TABS.applicantDetails ? (
              <ApplicantDetails responsiblePersons={vacancy.responsiblePersons} />
            ) : (
              <Applicants vacancyId={vacancy._id} />
            ),
        },
      ]}
    />
  );
};

export default VacancyDetails;
